import React from 'react';

/**
 * Risk badges row. Renders one pill per attention item, coloured by its
 * riskPriority (1/2/3 → CSS modifier class; anything else falls back to p3).
 * Label text comes from the backend (`itemName`). Renders nothing when empty.
 */
const badgeClass = (riskPriority) =>
  `ssbs__badge--p${[1, 2, 3].includes(riskPriority) ? riskPriority : 3}`;

export default function AttentionBadges({ items = [] }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <div className="ssbs__badges">
      {items.map((item, idx) => (
        <span
          key={`${item.itemName}-${idx}`}
          className={`ssbs__badge ${badgeClass(item.riskPriority)}`}
        >
          <span className="ssbs__badge-dot" />
          <span className="ssbs__badge-text">{item.itemName}</span>
        </span>
      ))}
    </div>
  );
}
